module.exports = __webpack_public_path__ + "img/ic24PersondataNew.4a509e8c.svg";